import React from 'react';
import styleable from 'react-styleable';

import CircularProgress from '@material-ui/core/CircularProgress';

import css from './index.scss';


const LoaderSpinner = () => (
    <div className={css.loader}>
        <CircularProgress />
        <p className={css.text}>Uploading...</p>
    </div>
);

export default styleable(css)(LoaderSpinner);



// WEBPACK FOOTER //
// ./app/components/curriculum-documents/loader-spinner/index.js